import cloneDeep from 'lodash/cloneDeep'
import deepmerge from 'deepmerge'

import * as ModelTypes from '@models/types'

import type { ModuleState } from '@redux/modules/types'

const DELETE_ENTITY = 'realbase/entity/DELETE_ENTITY'
const REPLACE_ENTITY = 'realbase/entity/REPLACE_ENTITY'
const UPDATE_ENTITY = 'realbase/entity/UPDATE_ENTITY'

// Add Entities & their Model Type Reference here
export type EntitiesState = {
// START ENTITY TYPES
  _updates: {},
  activities: { [key: number | string]: ModelTypes.ActivityModel },
  adCopies: { [key: number]: ModelTypes.AdCopyModel },
  addresses: { [key: number | string]: ModelTypes.AddressModel },
  agencies: { [key: number | string]: ModelTypes.AgencyModel },
  agencyContacts: { [key: number | string]: ModelTypes.AgencyContactModel },
  agencyOrderBundles: { [key: number | string]: ModelTypes.AgencyOrderBundleModel },
  agencyPaymentMethods: { [key: number]: ModelTypes.AgencyPaymentMethodModel },
  agencyPortals: { [key: number | string]: ModelTypes.AgencyPortalModel },
  agencyProviderDeadlineGroups: { [key: number | string]: ModelTypes.AgencyProviderDeadlineGroupModel },
  agencyProviderPackages: { [key: number | string]: ModelTypes.AgencyProviderPackageModel },
  agencyProviderPriceOverrides: { [key: number | string]: ModelTypes.AgencyProviderPriceOverrideModel },
  agencyProviders: { [key: number | string]: ModelTypes.AgencyProviderModel },
  agencyPublications: { [key: number | string]: ModelTypes.AgencyPublicationModel },
  agencyTags: { [key: number]: ModelTypes.AgencyTagModel },
  agents: { [key: number | string]: ModelTypes.AgentModel },
  apiKeys: { [key: number | string]: ModelTypes.ApiKeyModel },
  apiLogs: { [key: number | string]: ModelTypes.ApiLogModel },
  artworkPages: { [key: number | string]: ModelTypes.ArtworkPageModel },
  artworkReviews: { [key: number]: ModelTypes.ArtworkReviewModel },
  artworks: { [key: number]: ModelTypes.ArtworkModel },
  assetLibraries: { [key: number | string]: ModelTypes.AssetLibraryModel },
  attachments: { [key: number | string]: ModelTypes.AttachmentModel },
  auditLogs: { [key: number | string]: ModelTypes.AuditLogModel },
  billingTypes: { [key: number]: ModelTypes.BillingTypeModel },
  bookings: { [key: number | string]: ModelTypes.BookingModel },
  brandColours: { [key: number | string]: ModelTypes.BrandColourModel },
  brandCustomProfiles: { [key: number | string]: ModelTypes.BrandCustomProfileModel },
  brandGroupMembers: { [key: number | string]: ModelTypes.BrandGroupMemberModel },
  brandGroupProviders: { [key: number | string]: ModelTypes.BrandGroupProviderModel },
  brandGroupPublications: { [key: number | string]: ModelTypes.BrandGroupPublicationModel },
  brandGroups: { [key: number | string]: ModelTypes.BrandGroupModel },
  brandProviders: { [key: number | string]: ModelTypes.BrandProviderModel },
  // @ts-expect-error TS2724
  brandThemes: { [key: number | string]: ModelTypes.BrandThemeModel },
  brands: { [key: number | string]: ModelTypes.BrandModel },
  campaignCategories: { [key: number]: ModelTypes.CampaignCategoryModel },
  campaignCommercialCategories: { [key: number]: ModelTypes.CampaignCommercialCategoryModel },
  campaignComparables: { [key: number]: ModelTypes.CampaignComparableModel },
  campaignContacts: { [key: number]: ModelTypes.CampaignContactModel },
  campaignContributions: { [key: number]: ModelTypes.CampaignContributionModel },
  campaignDocuments: { [key: number]: ModelTypes.CampaignDocumentModel },
  campaignInspections: { [key: number]: ModelTypes.CampaignInspectionModel },
  campaignItems: { [key: number]: ModelTypes.CampaignItemModel },
  campaignPortalSyncs: { [key: number | string]: ModelTypes.CampaignPortalSyncModel },
  campaignPortals: { [key: number]: ModelTypes.CampaignPortalModel },
  campaignQuoteItems: { [key: number]: ModelTypes.CampaignQuoteItemModel },
  campaignQuoteSections: { [key: number]: ModelTypes.CampaignQuoteSectionModel },
  campaignQuoteTemplateItems: { [key: number | string]: ModelTypes.CampaignQuoteTemplateItemModel },
  campaignQuoteTemplateSections: { [key: number | string]: ModelTypes.CampaignQuoteTemplateSectionModel },
  campaignQuoteTemplates: { [key: number | string]: ModelTypes.CampaignQuoteTemplateModel },
  campaignQuotes: { [key: number | string]: ModelTypes.CampaignQuoteModel },
  campaignRuralCategories: { [key: number]: ModelTypes.CampaignRuralCategoryModel },
  campaignSaleMethods: { [key: number]: ModelTypes.CampaignSaleMethodModel },
  campaignStatuses: { [key: number | string]: ModelTypes.CampaignStatusModel },
  campaignTypes: { [key: number]: ModelTypes.CampaignTypeModel },
  campaigns: { [key: number | string]: ModelTypes.CampaignModel },
  chartData: { [key: number | string]: {} },
  comments: { [key: number | string]: ModelTypes.CommentModel },
  contacts: { [key: number]: ModelTypes.ContactModel },
  contracts: { [key: number | string]: object },
  conversations: { [key: number]: ModelTypes.ConversationModel },
  creditNoteItems: { [key: number]: ModelTypes.CreditNoteItemModel },
  creditNotes: { [key: number]: ModelTypes.CreditNoteModel },
  currentUser: { [key: number | string]: object },
  customDeadlines: { [key: number]: ModelTypes.CustomDeadlineModel },
  customFieldSets: { [key: number | string]: ModelTypes.CustomFieldSetModel },
  customFields: { [key: number | string]: ModelTypes.CustomFieldModel },
  customItemGroups: { [key: number | string]: ModelTypes.CustomItemGroupModel },
  customItems: { [key: number | string]: ModelTypes.CustomItemModel },
  customShortcodes: { [key: number | string]: object },
  dataStoreItems: { [key: number]: ModelTypes.DataStoreItemModel },
  defaultQuoteItems: { [key: number]: ModelTypes.DefaultQuoteItemModel },
  digitalTemplates: { [key: number]: ModelTypes.DigitalTemplateModel },
  favouriteOrderItems: { [key: number | string]: ModelTypes.FavouriteOrderItemModel },
  favouriteOrders: { [key: number | string]: ModelTypes.FavouriteOrderModel },
  financeApplications: { [key: number]: ModelTypes.FinanceApplicationModel },
  fontFamilies: { [key: number | string]: object },
  fonts: { [key: number | string]: object },
  geoCountries: { [key: number | string]: ModelTypes.GeoCountryModel },
  geoStates: { [key: number | string]: ModelTypes.GeoStateModel },
  geoSuburbs: { [key: number | string]: ModelTypes.GeoSuburbModel },
  imageLibraries: { [key: number | string]: ModelTypes.ImageLibraryModel },
  images: { [key: number | string]: ModelTypes.ImageModel },
  integrations: { [key: number]: ModelTypes.IntegrationModel },
  interactiveImages: { [key: number | string]: ModelTypes.InteractiveImageModel },
  invoiceAttachments: { [key: number | string]: ModelTypes.InvoiceAttachmentModel },
  invoiceItems: { [key: number | string]: ModelTypes.InvoiceItemModel },
  invoices: { [key: number | string]: ModelTypes.InvoiceModel },
  layoutTemplates: { [key: number]: ModelTypes.LayoutTemplateModel },
  loginSessions: { [key: number | string]: ModelTypes.LoginSessionModel },
  mediaLinks: { [key: number | string]: ModelTypes.MediaLinkModel },
  microsites: { [key: number | string]: ModelTypes.MicrositeModel },
  notifications: { [key: number | string]: ModelTypes.NotificationModel },
  orderBundleItems: { [key: number | string]: ModelTypes.OrderBundleItemModel },
  orderBundles: { [key: number | string]: ModelTypes.OrderBundleModel },
  orderItemTaskAttachments: { [key: number | string]: ModelTypes.OrderItemTaskAttachmentModel },
  orderItemTaskTypes: { [key: number | string]: ModelTypes.OrderItemTaskTypeModel },
  orderItemTasks: { [key: number | string]: ModelTypes.OrderItemTaskModel },
  orderItems: { [key: number | string]: ModelTypes.OrderItemModel },
  orderLeadTimes: { [key: number | string]: object },
  orders: { [key: number | string]: ModelTypes.OrderModel },
  paginationRules: { [key: number | string]: ModelTypes.PaginationRuleModel },
  paymentMethods: { [key: number | string]: ModelTypes.PaymentMethodModel },
  portalOptionValues: { [key: number | string]: ModelTypes.PortalOptionValueModel },
  portalOptions: { [key: number | string]: ModelTypes.PortalOptionModel },
  portals: { [key: number | string]: ModelTypes.PortalModel },
  pricingPlans: { [key: number | string]: ModelTypes.PricingPlanModel },
  priorityCampaigns: { [key: number]: ModelTypes.PriorityCampaignModel },
  processingFees: { [key: number | string]: ModelTypes.ProcessingFeeModel },
  providerAccounts: { [key: number | string]: ModelTypes.ProviderAccountModel },
  providerDeadlineGroups: { [key: number | string]: ModelTypes.ProviderDeadlineGroupModel },
  providerDisclaimers: { [key: number | string]: object },
  providerOrderCodes: { [key: number | string]: ModelTypes.ProviderOrderCodeModel },
  providerPackageItems: { [key: number | string]: object },
  providerPackages: { [key: number | string]: ModelTypes.ProviderPackageModel },
  providerPriceListItemOptionValues: { [key: number | string]: ModelTypes.ProviderPriceListItemOptionValueModel },
  providerPriceListItemOptions: { [key: number | string]: ModelTypes.ProviderPriceListItemOptionModel },
  providerPriceListItems: { [key: number | string]: ModelTypes.ProviderPriceListItemModel },
  providerPriceListProductUnlocks: { [key: number]: ModelTypes.ProviderPriceListProductUnlockModel },
  providerPriceLists: { [key: number | string]: ModelTypes.ProviderPriceListModel },
  providerProductCodes: { [key: number | string]: ModelTypes.ProviderProductCodeModel },
  providerServices: { [key: number | string]: object },
  providers: { [key: number | string]: ModelTypes.ProviderModel },
  publicationBookingItems: { [key: number | string]: ModelTypes.PublicationBookingItemModel },
  publicationBookings: { [key: number | string]: ModelTypes.PublicationBookingModel },
  publicationCompatiblePaginations: { [key: number | string]: object },
  publicationEditions: { [key: number | string]: ModelTypes.PublicationEditionModel },
  publicationInspections: { [key: number | string]: ModelTypes.PublicationInspectionModel },
  publicationOptionValues: { [key: number | string]: object },
  publicationOptions: { [key: number | string]: object },
  publicationOrders: { [key: number | string]: ModelTypes.PublicationOrderModel },
  publicationPaginationRules: { [key: number | string]: ModelTypes.PublicationPaginationRuleModel },
  publicationProducts: { [key: number | string]: ModelTypes.PublicationProductModel },
  publicationSpecialDeadlines: { [key: number | string]: object },
  publications: { [key: number | string]: ModelTypes.PublicationModel },
  roles: { [key: number | string]: ModelTypes.RoleModel },
  savedArtworkPages: { [key: number]: ModelTypes.SavedArtworkPageModel },
  savedArtworks: { [key: number]: ModelTypes.SavedArtworkModel },
  serviceCategories: { [key: number | string]: ModelTypes.ServiceCategoryModel },
  serviceProducts: { [key: number | string]: ModelTypes.ServiceProductModel },
  services: { [key: number | string]: ModelTypes.ServiceModel },
  smsLogs: { [key: number | string]: ModelTypes.SmsLogModel },
  statuses: { [key: number | string]: ModelTypes.StatusModel },
  subscribers: { [key: number]: ModelTypes.SubscriberModel },
  systems: { [key: number | string]: ModelTypes.SystemModel },
  tags: { [key: number | string]: ModelTypes.TagModel },
  teamMembers: { [key: number | string]: ModelTypes.TeamMemberModel },
  teams: { [key: number | string]: ModelTypes.TeamModel },
  templatePageCategories: { [key: number | string]: ModelTypes.TemplatePageCategoryModel },
  templatePages: { [key: number]: ModelTypes.TemplatePageModel },
  trackingLinks: { [key: number]: ModelTypes.TrackingLinkModel },
  trainingCourses: { [key: number | string]: ModelTypes.TrainingCourseModel },
  trainingLessons: { [key: number | string]: ModelTypes.TrainingLessonModel },
  trainingModules: { [key: number | string]: ModelTypes.TrainingModuleModel },
  users: { [key: number | string]: ModelTypes.UserModel },
  webhooks: { [key: number | string]: ModelTypes.WebhookModel },
// END ENTITY TYPES
}

const initialState: EntitiesState = {
// START ENTITIES STATE
  _updates: {},
  activities: {},
  adCopies: {},
  addresses: {},
  agencies: {},
  agencyContacts: {},
  agencyOrderBundles: {},
  agencyPaymentMethods: {},
  agencyPortals: {},
  agencyProviderDeadlineGroups: {},
  agencyProviderPackages: {},
  agencyProviderPriceOverrides: {},
  agencyProviders: {},
  agencyPublications: {},
  agencyTags: {},
  agents: {},
  apiKeys: {},
  apiLogs: {},
  artworkPages: {},
  artworkReviews: {},
  artworks: {},
  assetLibraries: {},
  attachments: {},
  auditLogs: {},
  billingTypes: {},
  bookings: {},
  brandColours: {},
  brandGroupMembers: {},
  brandGroupProviders: {},
  brandGroupPublications: {},
  brandGroups: {},
  brandProviders: {},
  brandThemes: {},
  brands: {},
  brandCustomProfiles: {},
  campaignCategories: {},
  campaignCommercialCategories: {},
  campaignComparables: {},
  campaignContacts: {},
  campaignContributions: {},
  campaignDocuments: {},
  campaignInspections: {},
  campaignItems: {},
  campaignPortalSyncs: {},
  campaignPortals: {},
  campaignQuoteItems: {},
  campaignQuoteSections: {},
  campaignQuoteTemplateItems: {},
  campaignQuoteTemplateSections: {},
  campaignQuoteTemplates: {},
  campaignQuotes: {},
  campaignRuralCategories: {},
  campaignSaleMethods: {},
  campaignStatuses: {},
  campaignTypes: {},
  campaigns: {},
  chartData: {},
  comments: {},
  contacts: {},
  contracts: {},
  conversations: {},
  creditNoteItems: {},
  creditNotes: {},
  currentUser: {},
  customDeadlines: {},
  customFieldSets: {},
  customFields: {},
  customItemGroups: {},
  customItems: {},
  customShortcodes: {},
  dataStoreItems: {},
  defaultQuoteItems: {},
  digitalTemplates: {},
  favouriteOrderItems: {},
  favouriteOrders: {},
  financeApplications: {},
  fontFamilies: {},
  fonts: {},
  geoCountries: {},
  geoStates: {},
  geoSuburbs: {},
  imageLibraries: {},
  images: {},
  integrations: {},
  interactiveImages: {},
  invoiceAttachments: {},
  invoiceItems: {},
  invoices: {},
  layoutTemplates: {},
  loginSessions: {},
  mediaLinks: {},
  microsites: {},
  notifications: {},
  orderBundleItems: {},
  orderBundles: {},
  orderItemTaskAttachments: {},
  orderItemTaskTypes: {},
  orderItemTasks: {},
  orderItems: {},
  orderLeadTimes: {},
  orders: {},
  paginationRules: {},
  paymentMethods: {},
  portalOptionValues: {},
  portalOptions: {},
  portals: {},
  pricingPlans: {},
  priorityCampaigns: {},
  processingFees: {},
  providerAccounts: {},
  providerDeadlineGroups: {},
  providerDisclaimers: {},
  providerOrderCodes: {},
  providerPackageItems: {},
  providerPackages: {},
  providerPriceListItemOptionValues: {},
  providerPriceListItemOptions: {},
  providerPriceListItems: {},
  providerPriceListProductUnlocks: {},
  providerPriceLists: {},
  providerProductCodes: {},
  providerServices: {},
  providers: {},
  publicationBookingItems: {},
  publicationBookings: {},
  publicationCompatiblePaginations: {},
  publicationEditions: {},
  publicationInspections: {},
  publicationOptionValues: {},
  publicationOptions: {},
  publicationOrders: {},
  publicationPaginationRules: {},
  publicationProducts: {},
  publicationSpecialDeadlines: {},
  publications: {},
  roles: {},
  savedArtworkPages: {},
  savedArtworks: {},
  serviceCategories: {},
  serviceProducts: {},
  services: {},
  smsLogs: {},
  statuses: {},
  subscribers: {},
  systems: {},
  tags: {},
  teamMembers: {},
  teams: {},
  templatePageCategories: {},
  templatePages: {},
  trackingLinks: {},
  trainingCourses: {},
  trainingLessons: {},
  trainingModules: {},
  users: {},
  webhooks: {},
// END ENTITIES STATE
}

// Normalized Data
type EntitiesActionFunctionPayload = {
  entities: Partial<EntitiesState>,
}

type ReducerResult = EntitiesActionFunctionPayload['entities'] & {
  type: string,
}

type Action = Partial<EntitiesState> &
  Partial<ModuleState> & {
    type?: string,
  }

export function updateEntities(payload: EntitiesActionFunctionPayload): ReducerResult {
  return { type: UPDATE_ENTITY, ...payload.entities }
}

export function replaceEntity(payload: EntitiesActionFunctionPayload): ReducerResult {
  return { type: REPLACE_ENTITY, ...payload.entities }
}

export function deleteEntity(payload: EntitiesActionFunctionPayload): ReducerResult {
  return { type: DELETE_ENTITY, ...payload.entities }
}

function cleanKeys(
  keys: (keyof Action)[] = [],
  removeKeys: (keyof Action)[] = [],
): (keyof EntitiesState)[] {
  removeKeys.forEach((removeKey) => {
    const index = keys.indexOf(removeKey)
    keys.splice(index, 1)
  })

  // @ts-expect-error TS2322
  return keys
}

// @ts-expect-error TS7006
function removeStaleEntities(currentEntityState, actionEntityState) {
  const currentKeys = Object.keys(currentEntityState)
  const actionKeys = Object.keys(actionEntityState)

  const updatedActionEntityState = cloneDeep(actionEntityState)

  actionKeys.forEach((actionKey) => {
    // If we already have the key, we need to check if the next one
    // is newer using cache key
    if (currentKeys.includes(actionKey)){
      const actionEntity = updatedActionEntityState[actionKey]
      const currentEntity = currentEntityState[actionKey]

      // Remove the entity from actionEntityState if it is older
      // than the one we already have in state
      if (
        typeof actionEntity === 'object'
        && actionEntity !== null
        && actionEntity.cache_key
        && currentEntity.cache_key
        && actionEntity.cache_key < currentEntity.cache_key
      ){
        delete updatedActionEntityState[actionKey]
      }
    }
  })

  return updatedActionEntityState
}

// Reducers
function addEntities(state: EntitiesState, action: Action): EntitiesState {
  // @ts-expect-error TS2345
  const keys = cleanKeys(Object.keys(action), ['type'])
  const newState = { ...state }

  // Don't merge arrays
  // @ts-expect-error TS7006
  const dontMerge = (_, source) => source
  const mergeOptions = { arrayMerge: dontMerge }

  keys.forEach((key) => {
    const updatedActionEntityState = removeStaleEntities(newState[key], action[key])

    newState[key] = deepmerge(newState[key], updatedActionEntityState, mergeOptions)
  })

  return newState
}

function replaceEntities(state: EntitiesState, action: Action): EntitiesState {
  // @ts-expect-error TS2345
  const keys = cleanKeys(Object.keys(action), ['type'])
  const newState = { ...state }

  keys.forEach((key) => {
    if (newState[key]){
      // @ts-expect-error TS2322
      newState[key] = { ...state[key] }

      // Keys of the item we need to replace
      // @ts-expect-error TS2769
      const itemKeys = Object.keys(action[key])
      itemKeys.forEach((itemKey) => {
        // @ts-expect-error TS7053
        newState[key][itemKey] = action[key][itemKey]
      })
    }
  })

  return newState
}

function removeEntities(state: EntitiesState, action: Action): EntitiesState {
  // @ts-expect-error TS2345
  const keys: (keyof EntitiesState)[] = cleanKeys(Object.keys(action), ['type'])
  const newState = { ...state }

  keys.forEach((key) => {
    if (newState[key]){
      // @ts-expect-error TS2322
      newState[key] = { ...state[key] }

      // Keys of the item we need to remove
      // @ts-expect-error TS2769
      const itemKeys = Object.keys(action[key])
      itemKeys.forEach((itemKey) => {
        // @ts-expect-error TS7053
        delete newState[key][itemKey]
      })
    }
  })

  return newState
}

export default function reducer(state: EntitiesState = initialState, action: Action = {}) {
  switch (action.type){
    case UPDATE_ENTITY:
      return addEntities(state, action)
    case REPLACE_ENTITY:
      return replaceEntities(state, action)
    case DELETE_ENTITY:
      return removeEntities(state, action)
    default:
      return state
  }
}
